import script from "./ChartSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ChartSkeleton.vue?vue&type=style&index=0&id=745204fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745204fc"]])

export default __exports__